import * as React from 'react'

function Filter({ fill, ...props }) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 21h-3A1.5 1.5 0 019 19.5v-5.693L3.442 8.25A1.5 1.5 0 013 7.192V4.5A1.5 1.5 0 014.5 3h15A1.5 1.5 0 0121 4.5v2.692a1.5 1.5 0 01-.442 1.058L15 13.807V19.5a1.5 1.5 0 01-1.5 1.5zm-9-16.5v2.692l6 6V19.5h3v-6.307l6-6V4.5h-15z"
        fill={fill}
      />
    </svg>
  )
}

export default Filter
